var _rect, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgQPauseSingle = function SvgQPauseSingle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 2.5,
    height: 12.81,
    x: 7.321,
    y: 5.595,
    rx: 1.25
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 2.5,
    height: 12.81,
    x: 14.722,
    y: 5.595,
    rx: 1.25
  })));
};
export { SvgQPauseSingle as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0iY3VycmVudENvbG9yIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cmVjdCB4PSI3LjMyMDgiIHk9IjUuNTk0NzMiIHdpZHRoPSIyLjUwMDQ5IiBoZWlnaHQ9IjEyLjgxMDUiIHJ4PSIxLjI1MDI0IiBmaWxsPSJjdXJyZW50Q29sb3IiLz4KPHJlY3QgeD0iMTQuNzIyMiIgeT0iNS41OTQ3MyIgd2lkdGg9IjIuNSIgaGVpZ2h0PSIxMi44MTA1IiByeD0iMS4yNSIgZmlsbD0iY3VycmVudENvbG9yIi8+Cjwvc3ZnPgo=";